import { API_AREAS_MGMT } from 'utils/constants'
import Api from './axiosInstance'
import { ListType } from 'components/areasManagement/areasList'

type FetchCostParams = {
  limit: number
  page: number
  search?: string
}

export const getAreasList = () => {
  return Api.get({ url: `${API_AREAS_MGMT.AREAS}` })
}

export const getPosAreasList = ({ limit, page, search }: FetchCostParams) => {
  const options: any = {}

  if (search) {
    options.search = search
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({ url: `${API_AREAS_MGMT.POS_AREAS}?${params}` })
}

export const updateArea = (data: ListType) => {
  return Api.patch({ url: `${API_AREAS_MGMT.AREAS}/${data._id}`, data: data })
}

export const deleteArea = (id: string) => {
  return Api.delete({ url: `${API_AREAS_MGMT.AREAS}/${id}` })
}

export const exportAreasList = () => {
  return Api.post({ url: `${API_AREAS_MGMT.AREAS}/export` })
}

type ListWithoutId = Omit<ListType, '_id'>
export const addArea = (data: ListWithoutId) => {
  return Api.post({ url: `${API_AREAS_MGMT.AREAS}`, data: data })
}
export const importAreas = async (data: any) => {
  return Api.post({
    url: `${API_AREAS_MGMT.AREAS}/import`,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const importPosAreas = async (data: any) => {
  return Api.post({
    url: `${API_AREAS_MGMT.POS_AREAS}/import`,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const fetchPosAreaCoordinates = () => {
  return Api.post({ url: API_AREAS_MGMT.POS_AREA_COORDS })
}

export const fetchAreaCoordinates = () => {
  return Api.post({ url: API_AREAS_MGMT.AREAS_COORDS })
}
